import { useEffect, useRef } from 'react';
import styles from '../styles/data.module.css';
import { TEXT } from '../texts';

interface ConfirmProps {
  title: string;
  text: string;
  action: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/** A modal question with Cancel focused first; Escape cancels. */
export function Confirm({ title, text, action, onCancel, onConfirm }: ConfirmProps): React.JSX.Element {
  const cancel = useRef<HTMLButtonElement>(null);
  // The page behind re-renders (e.g. upload progress); the focus must stay where the consultant put it.
  const onCancelRef = useRef(onCancel);
  onCancelRef.current = onCancel;
  useEffect(() => {
    cancel.current?.focus();
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onCancelRef.current();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return (
    <div className={styles.backdrop}>
      <div className={styles.dialog} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
        <h2 id="confirm-title" className={styles.dialogTitle}>
          {title}
        </h2>
        <p className={styles.text}>{text}</p>
        <div className={styles.dialogActions}>
          <button ref={cancel} type="button" className={styles.secondary} onClick={onCancel}>
            {TEXT.cancel}
          </button>
          <button type="button" className={styles.confirm} onClick={onConfirm}>
            {action}
          </button>
        </div>
      </div>
    </div>
  );
}
